import { Helmet } from "react-helmet-async";
import Hero from "../components/home/Hero";
import Benefits from "../components/home/Benefits";
import AboutPreview from "../components/home/AboutPreview";
import PricingPreview from "../components/home/PricingPreview";
import TrainersPreview from "../components/home/TrainersPreview";
import GalleryPreview from "../components/home/GalleryPreview";
import CTA from "../components/home/CTA";

function Home() {
    return (
        <>
            <Helmet>
                <title>Cris Gym Fitness | Sala fitness moderna si curata</title>
                <meta
                    name="description"
                    content="Cris Gym Fitness - sala moderna, curata si organizata. Antrenamente eficiente, echipamente moderne si rezultate reale."
                />
            </Helmet>

            <Hero />
            <Benefits />
            <GalleryPreview/>
            <AboutPreview />
            <PricingPreview />
            <TrainersPreview />
            <CTA />
        </>
    );
}

export default Home;